<script setup>
import { ref } from 'vue';
import { useMouseIdle } from '@/composables/use-mouse-idle';
import VideoPlayer from '@/views/Player/VideoPlayer.vue';
import SportLiveTvPlayerHeader from '@/sport-live-tv/components/sport-live-tv-player-header.vue';
import { useSportLiveTvPosition } from '@/sport-live-tv/composables/use-sport-live-tv-position';
import { SPORT_LIVE_TV_HIDE_HEADER_DELAY_MS } from '@/sport-live-tv/constants';

const props = defineProps({
  eventId: { type: Number, required: true },
  title: { type: String, required: true },
  subtitle: { type: String, default: '' },
  streamUrl: { type: String, required: true },
  isLive: { type: Boolean, default: false },
});

const emit = defineEmits(['back', 'stream-error']);

const viewportRef = ref(null);

const { isIdle } = useMouseIdle(viewportRef, SPORT_LIVE_TV_HIDE_HEADER_DELAY_MS);
const { trackTime } = useSportLiveTvPosition(() => props.eventId);
</script>

<template>
  <div ref="viewportRef" class="sport-live-tv-player" :class="{ 'sport-live-tv-player--idle': isIdle }">
    <VideoPlayer :link-video="streamUrl" :text-tracks="[]" liveui @timeupdate="trackTime" @error="emit('stream-error')" />
    <SportLiveTvPlayerHeader class="sport-live-tv-player__header" :title="title" :subtitle="subtitle" :is-live="isLive" @back="emit('back')" />
  </div>
</template>

<style lang="scss" scoped>
.sport-live-tv-player {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: $black;

  &__header {
    transition: opacity 0.3s ease-in-out;
  }

  &--idle {
    cursor: none;
  }

  &--idle &__header {
    opacity: 0;
    pointer-events: none;
  }
}
</style>
